import { Component } from '@angular/core';

@Component({
  selector: 'app-version',
  imports: [],
  templateUrl: './version.component.html',
  styleUrl: './version.component.less'
})
export class VersionComponent {

}
